module.exports = __webpack_public_path__ + "static/noble-96979334a563b21cd19b7a6e15bc10e6.mp4";